export const optionsChart = { plugins: { tooltip: true } };
